import * as React from "react";
import ScreenCodeToComponent from "../v1/screen_code_to_component";
import {LocalitiesService} from "../../service/v1/localities";
import Wait from "../wait";
import ChangePassword from "../v1/authorization/change_password";
import PopDetail from "../popdetail";

export default class BaseLayout extends React.Component {
    static self;
    constructor(props) {
        super(props);
        this.state = {
            left_menu: [],
            screen_code: <div>Loading...</div>,
            select_menu_at: 0,
            i: 0,
            j: 0,
            current_menu: 0,
            modules: [],
            showDropdown: false,
            sidebarOpen: true
        };
        BaseLayout.self = this;
        this.showMenuAt = this.showMenuAt.bind(this);
        this.showSubmenuAt = this.showSubmenuAt.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
    }

    componentDidMount() {
        let menu = JSON.parse(sessionStorage.getItem('decoded')).menu;
        if (menu.length > 0) {
            this.setState({
                left_menu: menu,
                screen_code: menu[0].screen_code,
                select_menu_at: 0
            });
        }
        document.getElementById('base-container').style.display = 'inherit';
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.showDropdown && !event.target.closest('.dropdown')) {
            this.setState({ showDropdown: false });
        }
    }

    showMenuAt(i, menu) {
        this.setState({
            screen_code: menu.screen_code,
            current_menu: i
        });
    }

    showSubmenuAt(i, j, submenu, d) {
        this.setState({
            screen_code: d.pane,
            select_menu_at: i
        });
        this.state.left_menu.forEach((d, ii) => {
            if (ii !== i) {
                const el = document.getElementById('sub-menu-' + ii);
                if (el) el.style.display = 'none';
            }
        });
        let div_submenu = document.getElementById('sub-menu-' + i);
        if (div_submenu) {
            if (!submenu) {
                div_submenu.style.display = div_submenu.style.display === 'inherit' ? 'none' : 'inherit';
            }
        }
    }

    toggleDropdown(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState(prevState => ({
            showDropdown: !prevState.showDropdown
        }));
    }

    toggleSidebar() {
        this.setState(prevState => ({ sidebarOpen: !prevState.sidebarOpen }));
    }

    handleMenuClick(e, action) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ showDropdown: false });
        if (action === 'logout') {
            BaseLayout.logout();
        } else if (action === 'changePassword') {
            PopDetail.show('Change Password', <ChangePassword key={new Date().getTime()} />, 35, 25);
        }
    }

    render() {
        const { left_menu, current_menu, showDropdown, sidebarOpen } = this.state;
        return (
            <div className={'base-container'} id={'base-container'} style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif' }}>
                {/* Toolbar */}
                <header style={{ backgroundColor: '#395d9a', color: 'white', width: '100%' }}>
                    <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 1rem', height: 56 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button
                                aria-label="Toggle menu"
                                onClick={this.toggleSidebar}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: 24,
                                    marginRight: 16,
                                    display: 'inline-block',
                                    cursor: 'pointer',
                                    lineHeight: 1
                                }}
                                className="sidebar-toggle"
                            >
                                <span className="fa fa-bars" />
                            </button>
                            <span style={{ fontSize: 20, fontWeight: 'bold', letterSpacing: 1 }}>NLUIS</span>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <div className="dropdown" style={{ display: 'inline-block', position: 'relative' }}>
                                <button
                                    type="button"
                                    className="fa fa-user"
                                    aria-haspopup="true"
                                    aria-expanded={showDropdown}
                                    style={{
                                        fontSize: 18,
                                        cursor: 'pointer',
                                        marginRight: 8,
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        color: 'white'
                                    }}
                                    onClick={this.toggleDropdown}
                                />
                                {showDropdown && (
                                    <div className="dropdown-menu" style={{
                                        position: 'absolute',
                                        right: 0,
                                        top: '100%',
                                        backgroundColor: 'white',
                                        border: '1px solid #ddd',
                                        borderRadius: 4,
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                        zIndex: 1000,
                                        minWidth: 160
                                    }}>
                                        <span style={{
                                            display: 'block',
                                            padding: '4px 12px',
                                            fontSize: 12,
                                            color: '#666'
                                        }}>{sessionStorage.getItem('username')}</span>
                                        <div style={{ borderTop: '1px solid #ddd', margin: '4px 0' }}></div>
                                        <button
                                            onClick={e => this.handleMenuClick(e, 'changePassword')}
                                            style={dropdownBtnStyle}
                                            onMouseOver={e => {
                                                e.currentTarget.style.backgroundColor = '#395d9a';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#333';
                                            }}
                                        >
                                            Change Password
                                        </button>
                                        <button
                                            onClick={e => this.handleMenuClick(e, 'logout')}
                                            style={dropdownBtnStyle}
                                            onMouseOver={e => {
                                                e.currentTarget.style.backgroundColor = '#395d9a';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#333';
                                            }}
                                        >
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </nav>
                </header>

                {/* Main Content Layout */}
                <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
                    {/* Sidebar */}
                    <aside
                        className={sidebarOpen ? 'sidebar open' : 'sidebar'}
                        style={{
                            width: sidebarOpen ? 220 : 0,
                            minWidth: sidebarOpen ? 180 : 0,
                            maxWidth: 240,
                            background: '#f7f9fa',
                            borderRight: '1px solid #e0e0e0',
                            transition: 'width 0.2s',
                            overflow: 'hidden',
                            zIndex: 10,
                            boxShadow: sidebarOpen ? '2px 0 8px rgba(0,0,0,0.04)' : 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'auto',
                            position: 'relative'
                        }}
                        aria-label="Sidebar navigation"
                    >
                        <nav style={{ padding: sidebarOpen ? '24px 0 0 0' : 0, width: '100%' }}>
                            {left_menu.map((d, i) => (
                                <div key={'left-menu-' + i}>
                                    <div
                                        style={{
                                            height: 40,
                                            fontSize: 15,
                                            padding: '0 16px',
                                            display: sidebarOpen ? 'flex' : 'none',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            background: i === current_menu ? '#395d9a' : 'transparent',
                                            color: i === current_menu ? 'white' : '#222',
                                            borderLeft: i === current_menu ? '4px solid #395d9a' : '4px solid transparent',
                                            fontWeight: i === current_menu ? 'bold' : 'normal',
                                            borderRadius: 4,
                                            marginBottom: 2,
                                            transition: 'background 0.2s, color 0.2s'
                                        }}
                                        className={i === current_menu ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}
                                        onClick={() => d.submenu.length > 0 ? this.showSubmenuAt(i, 0, false, d) : this.showMenuAt(i, d)}
                                    >
                                        <span className={'fa fa-' + d.icon + ' fa-lg'} style={{ marginRight: 10 }} />
                                        <span>{d.name}</span>
                                    </div>
                                </div>
                            ))}
                        </nav>
                    </aside>

                    {/* Main Content */}
                    <main style={{ flex: 1, padding: '24px 16px', overflow: 'auto', background: '#fff' }}>
                        {ScreenCodeToComponent.getScreenByCode(this.state.screen_code)}
                    </main>
                </div>
            </div>
        );
    }
    static logout() {
        sessionStorage.clear();
        window.location.reload();
    }
}

const dropdownBtnStyle = {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '8px 16px',
    color: '#333',
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: 15
};
